import {
	Component,
	Input,
	Output,
	EventEmitter,
	ViewEncapsulation,
	SimpleChanges,
	ChangeDetectionStrategy,
	OnChanges
} from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormGroup } from '@angular/forms';

import * as olciUtil from '../../../util';
import { MicroServicesService } from '../../core/services/micro-services.service';
@Component({
    selector: 'app-guest-selection-for-checkin',
    templateUrl: './guest-selection-for-checkin.component.html',
    styleUrls: ['./guest-selection-for-checkin.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GuestSelectionForCheckinComponent implements OnChanges {
	@Input() public bundle: any;
	@Input() public guestsNotCompleted: any[];
	@Input() public language: any;
	@Output() public onSubmit: EventEmitter<any> = new EventEmitter<any>();
	@Output() public selectItem: EventEmitter<any> = new EventEmitter<any>();
	@Output() public associateGuests: EventEmitter<Object> = new EventEmitter<Object>();

	public guestSelectorCheckbox: UntypedFormGroup;

	public brandName:string;

	constructor(
		private readonly location: Location, 
		private readonly microService: MicroServicesService) {
		this.brandName = this.microService.brand;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['guestsNotCompleted']) {
			this.createForm();
			this.updateForm();
		}
	}

	goBack(event: any) {
		event.preventDefault();
		this.location.back();
	}

	addGuests() {
		this.associateGuests.emit();
	}

	createForm() {
        // Initialize guests with a valid 'selectedForCheckin' property
        this.updateGuestSelection();
    }
     
    updateForm() {
        this.updateGuestSelection();
    }
 
    private updateGuestSelection() {
        this.guestsNotCompleted = this.guestsNotCompleted.map(guest => ({
          ...guest,
          selectedForCheckin: guest.selectedForCheckin ?? true
        }));
    }

	getGuestLastName(guest: any) {
		return olciUtil.getGuestLastName(guest);
	}
 
    selectGuest(event: any, guestId: number) {
        const guest = this.guestsNotCompleted.find(g => g.guestId === guestId);
        if (guest) {
            this.selectItem.emit(event?.detail?.id);
            guest.selectedForCheckin = event?.detail?.id?.isSelected;
         }
    }
 
    getDataForItemSelector(guest: any) {
        const data = {
          id: guest.guestId,
          title: guest.firstName + ' ' + this.getGuestLastName(guest),
          subTitle: '',
          img: guest.base64Image
        };
        return JSON.stringify(data);
    }
}
